import { makeAutoObservable } from "mobx";

class Store {

	isPlay = true;   // 是否开启音乐
	isGarden = false;   // 是否是园林漫游

	constructor() {
		makeAutoObservable(this)
	}

	setIsPlay(status) {
		this.isPlay = status;
	}

	setIsGarden(status) {
		this.isGarden = status;
	}

}

export default Store;